/**
 * compression-store.ts — Store global pour l'état de compression vidéo
 *
 * Pattern observable simple (pas de Zustand), survit à la navigation.
 * Utilise useSyncExternalStore pour l'intégration React.
 */

export type CompressionPhase = "idle" | "loading" | "compressing" | "done" | "error";

export interface CompressionState {
  phase: CompressionPhase;
  progress: number;
  fileName: string;
  originalSizeMB: number;
  error: string | null;
}

const INITIAL_STATE: CompressionState = {
  phase: "idle",
  progress: 0,
  fileName: "",
  originalSizeMB: 0,
  error: null,
};

let state: CompressionState = { ...INITIAL_STATE };
const listeners = new Set<() => void>();

export function getCompressionState(): CompressionState {
  return state;
}

export function setCompressionState(update: Partial<CompressionState>): void {
  state = { ...state, ...update };
  listeners.forEach((l) => l());
}

export function resetCompressionState(): void {
  state = { ...INITIAL_STATE };
  listeners.forEach((l) => l());
}

export function subscribeCompression(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
